import React from 'react';
import reactElementToJSXString from 'react-element-to-jsx-string';



const _passwordResetCompleted = (email) => {
  return (
    <div>
      <p>
        <strong>To:</strong>
        {email}
      </p>
      <br/>
      <p>We are contacting you to let you know that your password was successfully changed.</p>
      <p>If you did not initiate this password change yourself, contact us at support@tellmethis.org by responding to this email.</p>
    </div>

  )
}

const passwordResetCompleted = (email) => {
  return reactElementToJSXString(_passwordResetCompleted(email));
}


export default passwordResetCompleted;






